module.exports = __webpack_public_path__ + "img/9.157385e5.png";